// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { firestorePlugin } from 'vuefire'
// import VueFire from 'vuefire'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'
import 'firebase/compat/storage'  // Add this line
import { getStorage } from 'firebase/storage'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { store } from './store/store'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import { config } from './config/firebaseConfig'
import JsonExcel from 'vue-json-excel'
import InputTag from 'vue-input-tag'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import VueJsonp from 'vue-jsonp'

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(BootstrapVue)
Vue.use(require('vue-moment'))
Vue.use(firestorePlugin)
// Vue.use(VueFire)
Vue.use(VueJsonp)
Vue.component('icon', Icon)
Vue.component('downloadExcel', JsonExcel)
Vue.component('input-tag', InputTag)
Vue.component('quill-editor', quillEditor)
firebase.initializeApp(config)
firebase.firestore().settings({ timestampsInSnapshots: true })
const storage = firebase.storage()  // Add this line

export { storage }
export const db = firebase.firestore()
firebase.auth().onAuthStateChanged(function (user) {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    components: { App, Icon, JsonExcel, InputTag, quillEditor },
    template: '<App/>',
    store: store,
    router
  })
})



// WEBPACK FOOTER //
// ./src/main.js